import { mainApi } from "services/main";

export interface AdminPermissionsResponse {
  superAdmin: boolean;
  jeAccrualAdmin: boolean;
  sysAdmin: boolean;
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminPermissions: builder.query<AdminPermissionsResponse, void>({
      query: () => "user/adminPermissions",
    }),
  }),
  overrideExisting: false,
});

export const { useGetAdminPermissionsQuery } = extendedApi;
